import "./App.css";
import Header from "./Component/Header/Header";
import Footer from "./Component/Footer/Footer";
import Index from "./Pages/Home/Index/Index";
import Works from "./Pages/Works/Works";
import Services from "./Pages/Services/Services";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ChoosePlan from "./Pages/ChoosePlan/ChoosePlan";
import RegistrationForm from "./Pages/RegistrationForm/RegistrationForm";
import SelectPaymentOption from "./Pages/SelectPaymentOption/SelectPaymentOption";
import PaymentSuccess from "./Pages/PaymentSuccess/PaymentSuccess";
import PaymentFailed from "Pages/PaymentFailed/PaymentFailed";
import ContactUs from "./Pages/ContactUs/ContactUs";
import Inquiry from "Pages/ContactUs/Inquiry";
import TermAndCondition from "./Pages/TermAndCondition/TermAndCondition";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "./Pages/AboutUs/AboutUs";
import OurSolutions from "./Pages/OurSolutionDetails/OurSolutions";
import Testimonial from "./Pages/Testimonial/Testimonial";
import LeadManagement from "./Pages/SalesAutomation/LeadManagement";
import ContactManagement from "./Pages/SalesAutomation/ContactManagement";
import DealManagement from "./Pages/SalesAutomation/DealManagement";
import WorkflowAutomation from "./Pages/SalesAutomation/WorkflowAutomation";
import ApprovalProcess from "./Pages/ProcessManagement/ApprovalProcess";
import ScoringRules from "./Pages/ProcessManagement/ScoringRules";
import PaymentSchedule from "./Pages/InventoryManagement/PaymentSchedule";
import ProjectTowerUnit from "./Pages/InventoryManagement/ProjectTowerUnit";
import OfferManagement from "./Pages/InventoryManagement/OfferManagement";
import ReportAnalytics from "./Pages/InventoryManagement/ReportAnalytics";
import MarketingAttribution from "./Pages/MarketingAutomation/MarketingAttribution";
import BulkMarketing from "./Pages/MarketingAutomation/BulkMarketing";
import RolesProfilesTeamsSecurity from "./Pages/Security/RolesProfilesTeamsSecurity";
import DataSecurityCompliance from "./Pages/Security/DataSecurityCompliance";
import Media from "./Pages/Media/Media";
import CallingInfrastructureForPreSale from "./Pages/CallingInfrastructureForPreSale/CallingInfrastructureForPreSale";
import PerformanceManagement from "./Pages/PerformanceManagement/PerformanceManagement";
import BrokerInventoryManagement from "./Pages/BrokerInventoryManagement/BrokerInventoryManagement";
import AutomatedLeadCapturing from "./Pages/AutomatedLeadCapturing/AutomatedLeadCapturing";
import PerformanceAnalytics from "./Pages/PerformanceAnalytics/PerformanceAnalytics";
import Salesforce from "./Pages/Comparison/Salesforce";
import Hubspot from "./Pages/Comparison/Hubspot";
import RealtyRedefined from "./Pages/Comparison/RealtyRedefined";
import Zoho from "./Pages/Comparison/Zoho";
import Paramantra from "./Pages/Comparison/Paramantra";
import GetDemoRequest from "Pages/GetDemoRequest/GetDemoRequest";
import Cookies from "Component/Cookies/Cookies";
import CookiePolicy from "Pages/CookiePolicy/CookiePolicy";

function App() {
  return (
    <Router>
      <RenderComponent />
    </Router>
  );
}

function RenderComponent() {
  return (
    <div className="app-container">
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/testimonial" element={<Testimonial />} />
          {/*** START:: Features: Sales Automation ***/}
          <Route path="/sales-automation/lead-management" element={<LeadManagement />} />
          <Route path="/sales-automation/deal-management" element={<DealManagement />} />
          <Route path="/sales-automation/contact-management" element={<ContactManagement />} />
          <Route path="/sales-automation/workflow-automation" element={<WorkflowAutomation />} />
          {/*** END:: Features: Sales Automation ***/}
          {/*** START:: Features: Process Management ***/}
          <Route path="/process-management/approval-process" element={<ApprovalProcess />} />
          <Route path="/process-management/scoring-rules" element={<ScoringRules />} />
          {/*** END:: Features: Process Management ***/}
          {/*** START:: Features: Inventory Management ***/}
          <Route path="/inventory-management/project-tower-unit" element={<ProjectTowerUnit />} />
          <Route path="/inventory-management/payment-schedule" element={<PaymentSchedule />} />
          <Route path="/inventory-management/offer-management" element={<OfferManagement />} />
          <Route path="/inventory-management/report-analytics" element={<ReportAnalytics />} />
          {/*** END:: Features: Inventory Management ***/}
          {/*** START:: Features: Marketing Automation ***/}
          <Route path="/marketing-automation/marketing-attribution" element={<MarketingAttribution />} />
          <Route path="/marketing-automation/bulk-marketing" element={<BulkMarketing />} />
          {/*** END:: Features: Marketing Automation ***/}
          {/*** START:: Features: Comparison ***/}
          <Route path="/comparison/salesforce" element={<Salesforce />} />
          <Route path="/comparison/hubspot" element={<Hubspot />} />
          <Route path="/comparison/realty-redefined" element={<RealtyRedefined />} />
          <Route path="/comparison/zoho" element={<Zoho />} />
          <Route path="/comparison/paramantra" element={<Paramantra />} />
          {/*** END:: Features: Comparison ***/}
          {/*** START:: Features: Security ***/}
          <Route path="/security/roles-profiles-teams" element={<RolesProfilesTeamsSecurity />} />
          <Route path="/security/data-security-compliance" element={<DataSecurityCompliance />} />
          {/*** END:: Features: Security ***/}
          <Route path="/choose-plan" element={<ChoosePlan />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/request-a-demo" element={<GetDemoRequest />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/services" element={<Services />} />
          <Route path="/works" element={<Works />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/term-and-condition" element={<TermAndCondition />} />


          <Route path="/our-solutions" element={<OurSolutions />} />
          <Route path="/registration" exact element={<RegistrationForm />} />
          <Route path="/select-payment-option" element={<SelectPaymentOption />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed/:subscriptionId" element={<PaymentFailed />} />
          <Route path="/calling-infrastructure-for-pre-sale" element={<CallingInfrastructureForPreSale />} />
          <Route path="/media" element={<Media />} />
          <Route path="/performance-management" element={<PerformanceManagement />} />
          <Route path="/broker-inventory-management" element={<BrokerInventoryManagement />} />
          <Route path="/automated-lead-capturing" element={<AutomatedLeadCapturing />} />
          <Route path="/performance-analytics" element={<PerformanceAnalytics />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
        <Cookies />
        <Footer />
      </div>
    </div>
  );
}
export default App;
